/**
 * logout.ts
 *
 * Utility for handling user logout and redirecting to appropriate page.
 */
const BASE_URL = import.meta.env.VITE_HUSK_NEURON_URL;
import * as Sentry from "@sentry/react";

/**
 * Clears all cookies and redirects the user to the appropriate logout page.
 */
export const handleLogout = () => {
  Sentry.setUser(null);
  // Clear all cookies
  document.cookie.split(";").forEach((cookie) => {
    const name = cookie.split("=")[0].trim();
    const hostname = window.location.hostname;
    const rootDomain = hostname.split(".").slice(-2).join(".");

    document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
    document.cookie = `${name}=; path=/; domain=.${rootDomain}; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
  });

  const currentPath = window.location.pathname;
  const pathSegments = currentPath.split("/").filter(Boolean);

  let redirectPath = "/Security/AccessDenied"; // Default fallback

  if (currentPath.includes("/plant-details/") && pathSegments.length >= 2) {
    redirectPath = `/plant-details/${pathSegments[1]}`;
  } else if (currentPath.includes("/global-overview/") && pathSegments.length >= 2) {
    redirectPath = `/global-overview/${pathSegments[1]}`;
  }

  // Redirect to final URL with logout=true
  // console.log(`${BASE_URL}${redirectPath}?logout=true`);
  
  window.location.replace(`${BASE_URL}${redirectPath}?logout=true`);
};

export const clearCookiesAndRedirect = () => {
// Clear all cookies
  Sentry.setUser(null);
  document.cookie.split(";").forEach((cookie) => {
    
    const name = cookie.split("=")[0].trim();
    const hostname = window.location.hostname;
    const rootDomain = hostname.split(".").slice(-2).join(".");

    document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
    document.cookie = `${name}=; path=/; domain=.${rootDomain}; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
  });

  // Remove query params and reload clean URL
  const cleanUrl = window.location.origin + window.location.pathname;
  window.location.replace(cleanUrl);
};

  
